export default function getOperationDefinition({ definitions }) {
  return definitions.find((el) => el.kind === 'OperationDefinition').name.value;
}
